<template>
  <page
    v-loading="loading"
    layout="single"
    class="recordsView"
  >
    <template v-if="!isRecordsGrid">
      <records-navigation />
      <router-view />
    </template>

    <router-view v-if="isRecordsGrid" />
  </page>
</template>

<script>
import RecordsNavigation from '@/components/records/RecordsNavigation'
import { mapState } from 'vuex'

export default {
  name: "Records",
  components: {
    RecordsNavigation
  },
  data: () => ({
    loading: false,
    recordCheckerInterval: null
  }),
  computed: {
    isRecordsGrid() {
      return this.$route.name === 'records-grid'
    },
    ...mapState({
      currentRecord: state => state.records.currentRecord
    })
  },
  async mounted() {
    // this.recordCheckerInterval = setInterval(this.recordChecker, 5000)
    if (this.$route.params.id) {
      if (!this.currentRecord || this.$route.params.id !== this.currentRecord.id) {
        try {
          this.loading = true
          await this.$store.dispatch('records/getRecord', { id: this.$route.params.id })
          this.loading = false
        } catch (error) {
          this.loading = false
          this.$router.push({
            name: 'records-grid'
          })
        }
      }
    }
  },
  beforeDestroy() {
    // clearInterval(this.recordCheckerInterval)
  },
  methods: {
    async recordChecker() {
      if (this.$route.params.id && this.currentRecord) {
        await this.$store.dispatch('records/refreshCurrentRecord', {
          withPeople: false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.recordsView';
</style>